shadow$provide[265] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Now:{enumerable:true, get:function() {
  return Now;
}}});
var require$_DOT__DOT__SLASH_base_SLASH_parent_DOT_js = require("../base/parent.js");
class Now extends require$_DOT__DOT__SLASH_base_SLASH_parent_DOT_js.Parent {
  static initClass() {
    this.traits = ["node", "clock", "now"];
  }
  init() {
    let now;
    this.now = now = +new Date() / 1000;
    this.skew = 0;
    return this.time = {now, time:0, delta:0, clock:0, step:0,};
  }
  make() {
    this.clockParent = this._inherit("clock");
    return this._listen("clock", "clock.tick", this.tick);
  }
  unmake() {
    return this.clockParent = null;
  }
  change(changed, _touched, _init) {
    if (changed["date.now"]) {
      return this.skew = 0;
    }
  }
  tick(e) {
    const {seek, pace, speed} = this.props;
    const parent = this.clockParent.getTime();
    this.skew += parent.step * pace / speed;
    if (seek != null) {
      this.skew = seek;
    }
    this.time.now = this.time.time = this.time.clock = (this.props.now != null ? this.props.now : this.now) + this.skew;
    this.time.delta = this.time.step = parent.delta;
    return this.trigger(e);
  }
  getTime() {
    return this.time;
  }
}
Now.initClass();

};